import { render, staticRenderFns } from "./ServiceSelection.vue?vue&type=template&id=18bb42df&scoped=true"
import script from "./ServiceSelection.vue?vue&type=script&lang=js"
export * from "./ServiceSelection.vue?vue&type=script&lang=js"
import style0 from "./ServiceSelection.vue?vue&type=style&index=0&id=18bb42df&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18bb42df",
  null
  
)

export default component.exports